import { makeStyles, TableRow } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles(() => ({
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "stretch",
  },
}));

type Props = {
  style?: React.CSSProperties;
};

export const Row: React.FC<Props> = (props) => {
  const classnames = useStyles();
  const children = React.Children.map(props.children, (child, index) => {
    return React.isValidElement(child)
      ? React.cloneElement(child, {
          index,
        })
      : null;
  });

  return (
    <TableRow
      hover
      component="div"
      style={props.style}
      className={classnames.row}
    >
      {children}
    </TableRow>
  );
};
